var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-check-circle",
    d: "M70 35A35 35 0 1135 0a35 35 0 0135 35zM30.951 53.532l25.968-25.968a2.258 2.258 0 000-3.193l-3.194-3.194a2.258 2.258 0 00-3.193 0L29.354 42.355l-9.887-9.887a2.258 2.258 0 00-3.193 0l-3.193 3.193a2.258 2.258 0 000 3.193l14.677 14.678a2.258 2.258 0 003.193 0z",
    fill: "currentColor"
  })));
}

export default __webpack_public_path__ + "c4724cd3a9a8f44f2d0098700c319fe9.svg";
export { SvgCheckCircle as ReactComponent };